/*
 * @Description: 初始化与注册子应用
 * @Date: 2021-10-19 16:43:37
 */
import store from '../store/index';
// import { instance } from '@/main';
const {
  VUE_APP_SUBAPP_DOMAIN,
  VUE_APP_SUBAPP_INDUSTRY_PATH,
  VUE_APP_SUBAPP_ASP_PATH,
  VUE_APP_SUBAPP_SUPPLIER_PATH
} = process.env;
const getActiveRule = hash => location => {
  /* 
    // 跳转 v2 -> v3，v3 -> v3，v3通过v2 -> v3，v3 -> v3，这时候会导致页面跳转到#undefined，qiankun多次重载。
    v2 replace或者使用history.pushState不会有问题，只有v2使用push会出现。
    例，客户回访 -> 音频材料 -> 通过breadcrumb（V2）跳回客户回访 -> 音频资料，此时音频资料会多次重载。
    调试发现。v2push，最后v3 -> v3，会先跳转到一个undefined url(/#undefined)。
    未找到问题点，先这样处理 location.hash === '#undefined'。
  */
  return location.hash.startsWith(hash) || location.hash === '#undefined';
};

function loader(loading) {
  console.log('loading:', loading);
  // if (instance && instance.$children) {
  //   // instance.$children[0] 是App.vue，此时直接改动App.vue的isLoading
  //   instance.$children[0].isLoading = loading;
  // }
}
console.log(
  '子应用：',
  VUE_APP_SUBAPP_DOMAIN,
  VUE_APP_SUBAPP_INDUSTRY_PATH,
  VUE_APP_SUBAPP_ASP_PATH,
  VUE_APP_SUBAPP_SUPPLIER_PATH
);

const micros = [
  {
    name: 'industry',
    entry: `${VUE_APP_SUBAPP_DOMAIN}${VUE_APP_SUBAPP_INDUSTRY_PATH}`, // 根据环境设置，线上与本机打包需要在.env中写死
    activeRule: getActiveRule('#/industry')
  },
  {
    name: 'asp',
    entry: `${VUE_APP_SUBAPP_DOMAIN}${VUE_APP_SUBAPP_ASP_PATH}`, // 根据环境设置，线上与本机打包需要在.env中写死
    activeRule: getActiveRule('#/asp')
  },
  {
    name: 'supplier',
    entry: `${VUE_APP_SUBAPP_DOMAIN}${VUE_APP_SUBAPP_SUPPLIER_PATH}`, // 根据环境设置，线上与本机打包需要在.env中写死
    activeRule: getActiveRule('#/supplier')
  }
];

const apps = micros.map(item => {
  return {
    ...item,
    loader, // 给子应用配置加上loader方法
    container: '#subapp-container', // 子应用挂载的div,只可有一个容器
    // qiankun会把该项merge
    props: {
      // developer: item.developer, // 下发基础路由
      routerBase: item.activeRule, // 下发基础路由
      getGlobalState: store.getGlobalState // 下发getGlobalState方法。 onGlobalStateChange  setGlobalState  offGlobalStateChange 自动注入
    }
  };
});
export default apps;
